/**
 * This is a copy of the AuthOnlySubscriptions component. This is intended to show subscriptions that a reseller has
 * signed up for (but not expensed) on behalf of a customer. So these will be payment order 5 subscriptions.
 * 
 * This will appear for customers in the "Managed for me" tab in CustomerAppList (above the expensed subscriptions component).
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControlLabel, Grid, Link,
         Switch, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, TablePagination, Tooltip, Typography} from '@mui/material';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppLogo from '../ui/AppLogo';
import Cancel from '@mui/icons-material/Cancel';
import CallMade from '@mui/icons-material/CallMade';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';

import CheckCircle from '@mui/icons-material/CheckCircle';
import { green, red, amber } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();

const SubscriptionsSignedUpQuery = graphql`
query SubscriptionsSignedUpQuery($customerAccountId: UUID, $appName: String, $showCanceled: Int, $orderBy: Int, $direction: Int, $first: Int, $offset: Int) {
  getcustomerauthonlysubscriptionsresellersignup(customerAccountId: $customerAccountId, appName: $appName, showCanceled: $showCanceled, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {
    totalCount
    nodes {
      accountName
      appId
      appName
      appSku
      appLogo
      appUrl
      customerAppId
      customerAppStatus
      bcStatus
      sharedEmail
      useEmail
      pwd
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      // marginTop: -32,
    },
    flex: {
      flex: 1,
    },
    divider: {
      marginTop: 4,
      marginBottom: 4,
      marginLeft: 0,
    },
    paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    topButton: {
      marginTop: 15
    },
    appnameitem: {
      marginLeft: 8,
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 24,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      //borderBottom: 0,
    },
    tblHeadCellC: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      //borderBottom: 0,
    },
    tblCellWidth60: {
      textAlign: 'center',
      width: 60,
    },
    tblCellButton: {
      textAlign: 'center',
      width: 104,
    },
    actionButton: {
      width: 80,
    },

});

class SubscriptionsSignedUp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customerAccountId: this.props.customerAccountId,
      orderBy:           0,
      orderDir:          1,  
      appName:           '', 
      showCanceled:      0,
      page:              0,
      rowsPerPage:       10
    };  
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goToExternalApp(action, customerAppId, appId, appLink) {
    abEnvironment.goToExternalApp(action, customerAppId, appId, appLink);
  }

  render() {
    const { isAuthenticated, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    const statusOk = green[300];
    const statusCancel = red[300];
    const statusWaiting = amber[400];

    if (!isAuthenticated() || needAssent()) { 
      return (<Redirect to='/home' />);
    }    
    let theAppSearch = '%';
    if (this.state.appName !== '') {
      theAppSearch = '%' + this.state.appName + '%';
    }

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0) {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let showCanceled = null;
    if (this.state.showCanceled === 1) {
      //show all subscriptions including canceled
      showCanceled = 1;
    }

    let managedByName = 'My agent';
    if (this.props.parentAccount != null) {
      managedByName = this.props.parentAccount.accountName;
    }

    return (
      <Grid container spacing={1} direction="row" >
        <Grid item xs={12}>
          <Grid container spacing={2} direction="row" alignItems="center">
            <Grid item>
              <SearchField
                  id="appName"
                  label="Search by app name"
                  value={this.state.appName}
                  onChange={this.handleChange('appName')}
                />

            </Grid>

            <Grid item>
              <FormControlLabel 
                style={{ marginBottom: -14 }}
                control={
                  <Switch
                    checked={this.state.showCanceled === 1}
                    onChange={(e, checked) => {
                      if (checked) {
                        this.setState({ showCanceled: 1, page: 0 });
                      } else {
                        this.setState({ showCanceled: 0, page: 0 });
                      }
                    }}
                  />
                }
                label="Show cancelled"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={SubscriptionsSignedUpQuery}
            variables={{
              customerAccountId: this.state.customerAccountId,
              appName: theAppSearch,
              showCanceled: showCanceled,
              first: first,
              offset: offset
            }}
            render={({ error, props }) => {
              if (error) {
                logError(error.message);
                return (
                  <ServerError />
                );
              } else if (props) {
                // Determine offset information
                let totalCount = props.getcustomerauthonlysubscriptionsresellersignup.totalCount;

                let theSubs = props.getcustomerauthonlysubscriptionsresellersignup.nodes;
                
                return (
                  <div className={classes.paper}>
                    <TableContainer>
                      <Table>
                        <TableHead className={classes.tblHead}>
                          <TableRow className={classes.tblHeadRow}>
                            <TableCell className={classes.tblHeadCell}>App</TableCell>
                            <TableCell className={classes.tblHeadCell}>Sharing model</TableCell>
                            <TableCell className={classes.tblHeadCellC}>Status</TableCell>
                            <TableCell className={classes.tblHeadCell}></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {theSubs.map(n => {

                            let sublink = 'subscriptionview?customerAppId=' + n.customerAppId;
    
                            /*
                             * Determine the model and status we want to show.
                             */
                            let theStatus = 0;
                            let sharingModelText = managedByName + ' will sign up for this app.';
                            if (n.useEmail != null && n.useEmail.length > 0 && n.pwd != null && n.pwd.length > 0) {
                              theStatus = 1;
                              sharingModelText = managedByName + ' has signed up for this app.';
                            }
                            

                            // make sure link url is prefixed correctly
                            let appUrlWithProtocol = '';
                            if (n.appUrl || n.appUrl !== '') {
                              appUrlWithProtocol = (n.appUrl.startsWith("http://") || n.appUrl.startsWith("https://")) ? n.appUrl :  "https://" + n.appUrl;
                            }

                            return (
                              <TableRow key={n.customerAppId}>

                                <TableCell>
                                    <Grid container justifyContent="flex-start" alignItems="center" className={classes.appgrid}>
                                      <Grid item>
                                        <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/>
                                      </Grid>
                                      <Grid item className={classes.appnameitem}>
                                        <Link component="button" 
                                              variant="body2"
                                              onClick={this.goTo.bind(this, sublink)}>
                                          {n.appName}
                                        </Link>
                                        {n.appSku != null && n.appSku !== '' && n.appSku !== n.appName &&
                                        <Typography variant="body2">{n.appSku}</Typography>
                                        }
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                <TableCell><Typography>{sharingModelText}</Typography></TableCell>
                                <TableCell className={classes.tblCellWidth60}>
                                  {n.customerAppStatus === 0 && theStatus === 1 &&                                  
                                  <CheckCircle htmlColor={statusOk}/>}
                                  {n.customerAppStatus === 0 && theStatus === 0 &&
                                  <Tooltip title="Waiting for setup">
                                    <HourglassEmpty htmlColor={statusWaiting}/>
                                  </Tooltip>}
                                  {n.customerAppStatus === 2 &&
                                  <Cancel htmlColor={statusCancel}/>}
                                </TableCell>
                                <TableCell className={classes.tblCellButton}>
                                  {theStatus === 1 &&
                                  <Button className={classes.actionButton}
                                          color="primary" variant="outlined" 
                                          disabled={appUrlWithProtocol === ""}
                                          onClick={() => { this.goToExternalApp('appLogin', n.customerAppId, null, appUrlWithProtocol) }}>
                                    Login<CallMade/>
                                  </Button>}
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <div style={{ marginTop: '10px' }}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </div>
                  </div>
                )

              }
              return (
                <LoadingSpinner />
              );
            }}
          />
        </Grid>
      </Grid>
    );
  }

}
  
SubscriptionsSignedUp.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(SubscriptionsSignedUp);
